export default "__VITE_ASSET__D0xRrbW1__"